import { plainToInstance } from 'class-transformer'
import { IsEnum, IsInt, IsNotEmpty, IsNumber, IsOptional, IsPositive } from 'class-validator'

import { DateFormat } from '@agroone/dates'
import { IsDateValidate } from '@agroone/helpers'
import { CostUnit } from '../enums/cost-unit.enum'
import { SaveReporting } from './save-reporting'
export class SaveFarmContract extends SaveReporting {
  public static override build(raw: any) {
    return plainToInstance(SaveFarmContract, raw)
  }

  @IsInt()
  @IsPositive()
  @IsOptional()
  id?: number

  @IsNumber()
  @IsPositive()
  @IsNotEmpty()
  cost!: number

  @IsEnum(CostUnit)
  @IsNotEmpty()
  costUnit!: CostUnit

  @IsOptional()
  @IsDateValidate(DateFormat.YYYY_MM_DD)
  effectiveDate?: Date

  @IsNumber()
  @IsNotEmpty()
  campaignId!: number

  @IsNumber()
  @IsNotEmpty()
  cropTypeId!: number

  @IsNumber()
  @IsNotEmpty()
  farmId!: number
}
